export default __webpack_public_path__ + "static/media/SJA1510.34I-42085_-25231_0.c0f32be3.jpg";